<div class="item-message">
  <app-dynamic-content [content]="content"></app-dynamic-content>
  <div class="overlay"></div>
</div>
